export interface Category {
  name: string;
  url: string;
  seq: string;
  query: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    seq: 'cat-shoes-01',
    query: 'Stylish%20modern%20sneakers%20and%20shoes%20collection%20on%20minimal%20white%20background%2C%20fashion%20footwear%20product%20photography%20with%20soft%20natural%20lighting%2C%20clean%20aesthetic%20editorial%20style%2C%20warm%20neutral%20tones%2C%20professional%20product%20display%20with%20subtle%20shadows%2C%20high%20end%20fashion%20catalog%20look',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    seq: 'cat-hoodies-02',
    query: 'Premium%20hoodies%20and%20sweaters%20flat%20lay%20on%20clean%20cream%20background%2C%20minimalist%20streetwear%20fashion%20product%20photography%20with%20soft%20diffused%20lighting%2C%20warm%20beige%20and%20neutral%20tones%2C%20editorial%20catalog%20aesthetic%2C%20cozy%20textile%20texture%20visible%2C%20professional%20product%20display',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    seq: 'cat-tshirts-03',
    query: 'Designer%20t-shirts%20collection%20neatly%20folded%20on%20minimal%20white%20surface%2C%20contemporary%20fashion%20product%20photography%20with%20soft%20natural%20window%20light%2C%20clean%20aesthetic%20with%20warm%20neutral%20backdrop%2C%20editorial%20style%20clothing%20display%2C%20premium%20fabric%20texture%20showing',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    seq: 'cat-jackets-04',
    query: 'Trendy%20jackets%20and%20outerwear%20displayed%20on%20minimal%20wooden%20hangers%20against%20cream%20wall%2C%20fashion%20product%20photography%20with%20soft%20studio%20lighting%2C%20warm%20earth%20tones%20and%20neutral%20palette%2C%20editorial%20clothing%20catalog%20aesthetic%2C%20high%20quality%20textile%20details',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    seq: 'cat-pants-05',
    query: 'Modern%20pants%20and%20shorts%20collection%20laid%20flat%20on%20light%20warm%20background%2C%20minimalist%20fashion%20product%20photography%20with%20soft%20even%20lighting%2C%20neutral%20beige%20and%20cream%20tones%2C%20clean%20editorial%20catalog%20style%2C%20premium%20fabric%20textures%20visible',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    seq: 'cat-headwear-06',
    query: 'Stylish%20caps%20and%20headwear%20displayed%20on%20minimal%20white%20pedestal%2C%20contemporary%20fashion%20accessory%20product%20photography%20with%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20clean%20editorial%20aesthetic%2C%20premium%20headwear%20collection%20catalog%20look',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    seq: 'cat-sets-07',
    query: 'Coordinated%20fashion%20sets%20and%20matching%20outfits%20displayed%20on%20minimal%20cream%20background%2C%20product%20photography%20with%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20fashion%20catalog%20style%2C%20complete%20outfit%20ensembles%20harmoniously%20arranged',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    seq: 'cat-underwear-08',
    query: 'Premium%20underwear%20and%20basics%20neatly%20folded%20on%20soft%20cream%20fabric%20background%2C%20minimalist%20product%20photography%20with%20gentle%20diffused%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20catalog%20aesthetic%2C%20soft%20cotton%20texture%20visible',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    seq: 'cat-jersey-09',
    query: 'Sports%20jerseys%20collection%20displayed%20flat%20on%20minimal%20white%20surface%2C%20athletic%20fashion%20product%20photography%20with%20soft%20studio%20lighting%2C%20warm%20neutral%20backdrop%2C%20clean%20editorial%20catalog%20style%2C%20premium%20sportswear%20fabric%20details%20showing',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    seq: 'cat-accessories-10',
    query: 'Fashion%20accessories%20collection%20including%20jewelry%20and%20watches%20on%20minimal%20cream%20surface%2C%20product%20photography%20with%20soft%20warm%20lighting%2C%20neutral%20elegant%20aesthetic%2C%20editorial%20catalog%20style%2C%20premium%20accessories%20display%20with%20subtle%20reflections',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    seq: 'cat-bags-11',
    query: 'Designer%20bags%20and%20handbags%20collection%20on%20minimal%20white%20pedestal%2C%20luxury%20fashion%20product%20photography%20with%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20clean%20editorial%20aesthetic%2C%20premium%20leather%20texture%20visible%2C%20elegant%20catalog%20display',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    seq: 'cat-belts-12',
    query: 'Premium%20belts%20collection%20elegantly%20coiled%20on%20minimal%20cream%20surface%2C%20fashion%20accessory%20product%20photography%20with%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20catalog%20aesthetic%2C%20genuine%20leather%20texture%20and%20buckles%20detailed',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    seq: 'cat-perfumes-13',
    query: 'Luxury%20perfume%20bottles%20collection%20displayed%20on%20minimal%20white%20marble%20surface%2C%20elegant%20product%20photography%20with%20soft%20warm%20lighting%2C%20neutral%20sophisticated%20aesthetic%2C%20editorial%20beauty%20catalog%20style%2C%20glass%20bottles%20with%20subtle%20reflections%20and%20golden%20accents',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    seq: 'cat-other-14',
    query: 'Curated%20miscellaneous%20lifestyle%20products%20and%20gadgets%20arranged%20on%20minimal%20cream%20background%2C%20product%20photography%20with%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20catalog%20style%2C%20diverse%20items%20harmoniously%20displayed%20with%20clean%20composition',
  },
];